import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ConfBadge, PageHeader } from "@/components/shared";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function AdminConfidentiality() {
  const { tenantId } = useAuth();
  const [rows, setRows] = useState([]);

  const load = () => {
    if (!tenantId) return;
    api.get(`/tenants/${tenantId}/confidentiality-classes`).then(({ data }) => setRows(data)).catch((e) => toast.error(errMsg(e)));
  };
  useEffect(load, [tenantId]); // eslint-disable-line

  const save = async (row, patch) => {
    try {
      await api.post(`/tenants/${tenantId}/confidentiality-classes`, { ...row, ...patch });
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="space-y-10">
      <PageHeader
        testid="admin-confidentiality-header"
        eyebrow="Administration"
        title="Confidentiality policy manager"
        description="Export and download are separate security surfaces from view. Policies here are enforced server-side on every download and export."
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6" data-testid="confidentiality-list">
        {rows.map((r) => (
          <div key={r.id} className="panel h-full p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-display text-xl">{r.name}</h3>
              <ConfBadge level={r.level} />
            </div>
            <div className="mt-6 space-y-4 text-sm">
              <label className="flex items-center justify-between gap-4">
                Download allowed
                <Switch data-testid={`conf-download-${r.level}`} checked={!!r.download_allowed} onCheckedChange={(v) => save(r, { download_allowed: v })} />
              </label>
              <label className="flex items-center justify-between gap-4">
                Export allowed
                <Switch data-testid={`conf-export-${r.level}`} checked={!!r.export_allowed} onCheckedChange={(v) => save(r, { export_allowed: v })} />
              </label>
              <label className="flex items-center justify-between gap-4">
                Retention (months)
                <Input
                  data-testid={`conf-retention-${r.level}`}
                  type="number"
                  defaultValue={r.retention_months}
                  onBlur={(e) => save(r, { retention_months: Number(e.target.value) })}
                  className="h-9 w-24 rounded-none text-right font-mono text-xs"
                />
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
